import React from 'react';

function CreatePasskeyScreen({ 
  isVisible, 
  isVerifying, 
  onVerify, 
  onCancel 
}) {
  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10000,
      backdropFilter: 'blur(4px)'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '32px',
        maxWidth: '450px',
        width: '90%',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
        
        textAlign: 'center'
      }}>
        <div style={{ marginBottom: '24px' }}>
          <div style={{
            width: '64px',
            height: '64px',
            margin: '0 auto 16px',
            backgroundColor: '#f0f7ff',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '32px'
          }}>
            🔐
          </div>
          <h3 style={{ margin: 0, fontSize: '22px', fontWeight: '600', color: '#333' }}>Create Passkey</h3>
        </div>
        <div>
          <p style={{ marginBottom: '24px', color: '#666', fontSize: '15px', lineHeight: '1.6' }}>
           Setup a Mastercard payment passkey for safer, easier card access and verification. Please allow this action to create a passkey (fingerprint, face recognition, or PIN).
          </p>
          <div style={{
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '24px',
            border: '1px solid #e9ecef'
          }}>
            <p style={{ margin: 0, color: '#495057', fontSize: '13px', lineHeight: '1.5' }}>
              <strong>💡 Tip:</strong> Your device will prompt you to verify your identity using biometrics or your device PIN.
            </p>
          </div>
          <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
            <button
              type="button"
              className="settings-btn"
              onClick={onCancel}
              disabled={isVerifying}
              style={{ 
                width: '100%', 
                padding: '14px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '15px',
                fontWeight: '500',
                cursor: isVerifying ? 'not-allowed' : 'pointer',
                opacity: isVerifying ? 0.6 : 1
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="settings-btn save-btn"
              onClick={onVerify}
              disabled={isVerifying}
              style={{ 
                width: '100%',
                padding: '14px',
                backgroundColor: isVerifying ? '#ccc' : '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '15px',
                fontWeight: '600',
                cursor: isVerifying ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              {isVerifying ? (
                <>
                  <span style={{ 
                    display: 'inline-block',
                    width: '16px',
                    height: '16px',
                    border: '2px solid white',
                    borderTopColor: 'transparent',
                    borderRadius: '50%',
                    animation: 'spin 0.8s linear infinite'
                  }}></span>
                  Creating...
                </>
              ) : (
                <>
                  🔓 Create Passkey
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreatePasskeyScreen;
